import Csm from '@/domain/csm/entity/csm.entity';
import Segment from '@/domain/segment/entity/segment.entity';
import Seller from '@/domain/seller/entity/seller.entity';
import LeadOrigin from '@/domain/lead-origin/entity/lead-origin.entity';
import LeadSource from '@/domain/lead-source/entity/lead-source.entity';
import Portfolio from '@/domain/portfolio/entity/portfolio.entity';
import IntegrationType from '@/domain/integration-type/entity/integration-type.entity';
import CompetingFirm from '@/domain/competing-firm/entity/competing-firm.entity';

export default class ContractAdditionalData {
  csm: Csm;

  segment: Segment;

  seller: Seller;

  leadSource: LeadSource;

  leadOrigin: LeadOrigin;

  avgMonthlySales: number;

  healthScore: number;

  nps: number;

  portfolio: Portfolio;

  potential: Portfolio;

  integrationType: IntegrationType;

  competingFirm: CompetingFirm;

  constructor(obj: any = {}) {
    this.csm = obj.csm || null;
    this.segment = obj.segment || null;
    this.seller = obj.seller || null;
    this.leadSource = obj.leadSource || null;
    this.leadOrigin = obj.leadOrigin || null;
    this.avgMonthlySales = obj.avgMonthlySales || null;
    this.healthScore = obj.healthScore || null;
    this.nps = obj.nps || null;
    this.portfolio = obj.portfolio || null;
    this.potential = obj.potential || null;
    this.integrationType = obj.integrationType || null;
    this.competingFirm = obj.competingFirm || null;
  }

  public static of(obj: any): ContractAdditionalData {
    return new ContractAdditionalData(obj || {});
  }

  public static ofList(obj: any[]): ContractAdditionalData[] {
    return obj.map(this.of);
  }
}
